<div class="auth-container">
  <h2>Join Bacon Arcade</h2>
  <p class="subtitle">Level up your gaming experience</p>

  <!--  <app-social-login></app-social-login>-->

  <button class="sign_in btn" (click)="login()">Sign in</button>
<!--  <button class="sign_in btn" (click)="logout()">Log out</button>-->

  <!--  <div class="separator">-->
  <!--    <span>or</span>-->
  <!--  </div>-->

  <!--  <p>Already have an account?-->
  <!--    <p-button (click)="login()">Sign in</p-button>-->
  <!--  </p>-->

  <app-terms></app-terms>
</div>
